import { AlertTriangle, X, Info } from 'lucide-react';
import { Button } from '@etherisc/ui-kit';

interface ErrorDisplayProps {
  title: string;
  message: string;
  details?: string[];
  suggestion?: string;
  onDismiss?: () => void;
  className?: string;
}

export function ErrorDisplay({
  title,
  message,
  details,
  suggestion,
  onDismiss,
  className = ''
}: ErrorDisplayProps) {
  return (
    <div className={`bg-red-50 border border-red-200 rounded-lg p-4 ${className}`}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <AlertTriangle className="h-5 w-5 text-red-400" />
        </div>
        
        <div className="ml-3 flex-1">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-medium text-red-800">
              {title}
            </h3>
            {onDismiss && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onDismiss}
                className="h-6 w-6 p-0 text-red-400 hover:text-red-600"
              >
                <X className="h-4 w-4" />
              </Button>
            )}
          </div>
          
          <div className="mt-2 text-sm text-red-700">
            <p>{message}</p>
          </div>

          {details && details.length > 0 && (
            <div className="mt-3">
              <div className="text-xs font-medium text-red-800 mb-1">
                Details:
              </div>
              <div className="bg-red-100 rounded p-2 text-xs text-red-700 font-mono">
                {details.length === 1 ? (
                  <div>{details[0]}</div>
                ) : (
                  <ul className="list-disc list-inside space-y-1">
                    {details.map((detail, index) => (
                      <li key={index}>{detail}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )}

          {suggestion && (
            <div className="mt-3 flex items-start">
              <Info className="h-4 w-4 text-blue-400 mt-0.5 flex-shrink-0" />
              <div className="ml-2">
                <div className="text-xs font-medium text-blue-800 mb-1">
                  Suggestion:
                </div>
                <div className="text-xs text-blue-700">
                  {suggestion}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
